import { Grid } from "@mui/material";
import { IconBuildingPlus } from "@tabler/icons-react";
import MxButtonStartIcon from "@rf-l1/buttons/MxButtonStartIcon";
import { useBuildingsContext } from "../../context/Buildings-contexts/BuildingsContext";
const ButtonAddBuilding = () => {
  const { addBuilding } = useBuildingsContext();

  const handleAddBuilding = () => {
    addBuilding();
  };

  return (
    <Grid container item xs={12} my={5}>
      <Grid item xs="auto" mx="auto">
        <MxButtonStartIcon
          onClick={handleAddBuilding}
          label="Agregar etapa"
          bgColorIcon="primary.main"
          colorText="grey.600"
          icon={<IconBuildingPlus size={19} color="white" />}
        />
      </Grid>
    </Grid>
  );
};

export default ButtonAddBuilding;
